import { render, staticRenderFns } from "./billType.vue?vue&type=template&id=be54c6e4&scoped=true&"
import script from "./billType.vue?vue&type=script&lang=js&"
export * from "./billType.vue?vue&type=script&lang=js&"
import style0 from "./billType.vue?vue&type=style&index=0&id=be54c6e4&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be54c6e4",
  null
  
)

export default component.exports